import script from "./GlobalSearchModal.vue?vue&type=script&setup=true&lang=js"
export * from "./GlobalSearchModal.vue?vue&type=script&setup=true&lang=js"

import "./GlobalSearchModal.vue?vue&type=style&index=0&id=7c81ce34&lang=css"

const __exports__ = script;

export default __exports__